//export const API_BASE_URL = 'http://localhost:8080/api';

export const API_BASE_URL = 'https://app.fieldtech.io/JobScheduler/api';

export const ROOT_CONTEXT = '/JobScheduler'; //Live Env
//export const ROOT_CONTEXT = '';  //Local Env
//export const API_BASE_URL = 'http://ap.ashtechsoftwares.com/api';

//export const API_BASE_URL = '/api';
export const ACCESS_TOKEN = 'accessToken';

export const SESSION_USER = 'sessionUser';

export const SSO_PARAMS = 'ssoParams';



export const APP_TITLE = 'Job Scheduler';

export const JOB_TYPE_UNSCHEDULE = '0';
export const JOB_TYPE_SCHEDULE = '1';

export const JOB_PRIORITY_LOW = '0';
export const JOB_PRIORITY_MEDIUM = '1';
export const JOB_PRIORITY_HIGH = '2';

export const APP_DATE_AND_TIME_FORAMT = 'MM/DD/YYYY hh:mm A';
export const DATE_FORAMT = 'MM/DD/YYYY';
export const TIME_FORMAT = 'hh:mm A';
export const BLANK_SPACE = ' ';

export const JOB_STATUS_SCHEDULED = 'Scheduled';
export const JOB_STATUS_UNSCHEDULED = 'Unscheduled';
export const JOB_STATUS_WORKING = 'Working';
export const JOB_STATUS_CLOSED = 'Closed';







